import React, { Suspense } from 'react';
import { Modal } from '@utex/ui-kit';

import { useTabs } from '../../hooks/useTabs';
import { useDefaultTabEffect } from '../../hooks/useDafaultTabEffect';
import { Layout } from '../Layout';
import { ErrorPanel } from '../ErrorPanel';
import { Loader } from '../Loader';
import { Menu } from './Menu';
import { Select } from './Select';
import { Content } from './Content';
import { useModalService } from '../../hooks/useModalService';

export const MainScreen: React.FC = () => {
  const { loading, tabs, error, refetch } = useTabs();
  useDefaultTabEffect(tabs);

  const { isOpened, closeImmediately } = useModalService();

  return (
    <Modal isOpen={isOpened} size={960} onRequestClose={closeImmediately} testId="withdraw-modal">
      <Suspense fallback={<Loader />}>
        <Layout
          loading={loading}
          error={error ? <ErrorPanel onRetry={refetch} /> : null}
          menu={<Menu />}
          select={<Select />}
          content={<Content />}
        />
      </Suspense>
    </Modal>
  );
};
